import React from 'react';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import CrudManager from '@/components/admin/CrudManager';

const backfill = async (doctor_id) => {
  if (!window.confirm('Backfill this doctor\'s current meet link across ALL their confirmed appointments (past and future)?')) return;
  try {
    const { data } = await api.post(`/admin/doctors/${doctor_id}/backfill-meet-link`);
    toast.success(`Updated ${data.updated} appointment${data.updated !== 1 ? 's' : ''}`);
  } catch (e) {
    toast.error(e?.response?.data?.detail || 'Backfill failed — is a meet link saved on this doctor?');
  }
};

const AdminDoctors = () => (
  <CrudManager
    title="Doctors"
    subtitle="Manage practitioner profiles. Saving a meet link auto-updates all future appointments for this doctor."
    endpoint="/admin/doctors"
    idField="doctor_id"
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'email', label: 'Email' },
      { key: 'credentials', label: 'Credentials' },
      { key: 'specialization', label: 'Specialization' },
      { key: 'meet_link', label: 'Meet link', render: (d) => (d.meet_link ? '✓ set' : '— not set') },
      { key: 'active', label: 'Active', render: (d) => d.active ? '✓' : '' },
    ]}
    initial={{ email: '', name: '', credentials: '', specialization: '', experience_years: 5, photo: '', bio: '', meet_link: '', active: true }}
    fields={[
      { key: 'email', label: 'Email (login)', required: true, help: 'A user account will be created with default password ChangeMe2026! — ask them to change it.' },
      { key: 'name', label: 'Name (incl. title)', required: true, placeholder: 'Dr. Aditi Sharma' },
      { key: 'credentials', label: 'Credentials', placeholder: 'BAMS, MD (Ayurveda)' },
      { key: 'specialization', label: 'Specialization' },
      { key: 'experience_years', label: 'Experience (years)', type: 'number' },
      { key: 'photo', label: 'Photo URL' },
      { key: 'bio', label: 'Bio', type: 'textarea', rows: 4 },
      { key: 'meet_link', label: 'Personal Google Meet / Zoom / Jitsi link', placeholder: 'https://meet.google.com/xxx-xxxx-xxx', help: 'Fixed room for ALL consultations. Get one from meet.google.com → New meeting → "Create a meeting for later". Saving auto-updates future appointments.' },
      { key: 'active', label: 'Active', type: 'checkbox' },
    ]}
    rowExtraActions={(d) => (
      <button
        onClick={() => backfill(d.doctor_id)}
        title="Backfill meet link across all past + future appointments"
        data-testid={`backfill-${d.doctor_id}`}
        className="text-sans_mute hover:text-sans_ink mr-3 inline-flex items-center"
        aria-label="Backfill meet link"
      >
        <RefreshCw className="w-4 h-4" strokeWidth={1.5} />
      </button>
    )}
  />
);

export default AdminDoctors;
